import type { ProductSource } from './analyticsEvents'

/**
 * Контекст открытия карточки товара.
 *
 * Знает его только вызывающая сторона (каталог, рекомендации в корзине, «вы заказывали»,
 * пуш), а нужен он событиям внутри модалки и в корзине. Прокидывать его пропсами через
 * модальный контейнер и стор — значит менять контракт `setSelectedDish` ради аналитики,
 * поэтому контекст живёт здесь: пишется в момент открытия, читается до следующего.
 *
 * Категория здесь же: в самом товаре её нет — она есть только в структуре каталога,
 * из которой карточку и открывают.
 */
export interface ProductOpenContext {
  source: ProductSource
  categoryId?: number
  /** Позиция в списке: отличает реальный спрос от места в выдаче. */
  position?: number
}

let current: ProductOpenContext = { source: 'unknown' }

export const setProductOpenSource = (
  source: ProductSource,
  meta: Omit<ProductOpenContext, 'source'> = {},
): void => {
  current = { source, ...meta }
}

export const getProductOpenContext = (): ProductOpenContext => current

export const getProductOpenSource = (): ProductSource => current.source
